import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getSellableProductTypes = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SELLABLE_PRODUCT_TYPE);
};

export const getItemBanks = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_ITEM_BANK);
};

export const getAllSellableProducts = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SELLABLE_PRODUCT, {
    params: { isActive: true },
  });
};

export const addSellableProduct = (product: any) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SELLABLE_PRODUCT,
    product,
    {}
  );
};

export const addSellableProductToExisting = (product: any) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_ADD_PRODUCT_EXISTING,
    {},
    {
      params: {
        sellableProductId: product.productId,
        subjectIds: product.subjectIds,
        isApproved: product.isApproved,
      },
    }
  );
};

export const deleteSellableProduct = (productId: number, userId: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SELLABLE_PRODUCT, {
    params: {
      sellableProductId: productId,
      userId: userId,
    },
  });
};

export const deleteSellableProductFromSubject = (
  productId: number,
  subjectId: number
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_ADD_PRODUCT_EXISTING,
    {
      params: {
        sellableProductId: productId,
        subjectId: subjectId,
      },
    }
  );
};

export const updateSellableProductSubject = (
  subjectId,
  sellableProductId,
  isPrimary
) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_SELLABLE_PRODUCT_SUBJECTS}?subjectId=${subjectId}&sellableProductId=${sellableProductId}&isPrimary=${isPrimary}`
  );
};
